module.exports = "/_next/static/images/arrow-down-0cbea30fc6acd182be2308a01bdccd95.svg";